import { fieldCheckboxName } from './FormData'

const firstAndLastName = (name: string) => {
  const splittedName = name?.split(' ')
  const splittedNameLength = splittedName?.length
  const firstName = splittedName?.[0] ?? ''
  const LastName = splittedNameLength > 1 ? splittedName?.splice(1, splittedNameLength + 1).join(' ') ?? '' : ''
  return {
    firstName: firstName,
    lastName: LastName,
  }
}

export const parseFormData = (
  formData: any,
  previousData: any,
  isEditScreen: boolean,
  mid: string,
  jfsUserId: string,
) => {
  let permissionArray: any = []
  // debugger
  Object.entries(formData).forEach(([key, value]: Array<any>) => {
    if (key?.includes(fieldCheckboxName)) {
      value?.map((item: any) => {
        if (item?.isChecked === true) {
          permissionArray?.push({ permissionId: item?.permissionId, permissionValue: 'Y' })
        } else if (item?.isChecked === false) {
          permissionArray?.push({ permissionId: item?.permissionId, permissionValue: 'N' })
        }
      })
    }
  })

  const similarData = {
    mobile: {
      countryCode: '91',
      number: formData?.mobile ?? ' ',
    },
    name: firstAndLastName(formData?.userName ?? ''),
    email: formData?.email,
    department: formData?.role ? formData?.role ?? '' : previousData?.department ?? '',
    entityId: mid,
    entityType: 1,
    userType: isEditScreen ? undefined : '11',
    jfsUserId: jfsUserId,
  }
  if (isEditScreen) {
    return {
      ...similarData,
      permissionEntryList: permissionArray,
    }
  } else {
    return {
      ...similarData,
      permissions: permissionArray,
    }
  }
}

export const hasDataChanged = (formData: any, previousData: any) => {
  /*if (formData.userName !== previousData.name) {
    return true
  } else if (formData.email !== previousData.email) {
    return true
  } else if (formData.mobile !== previousData.mobileNo) {
    return true
  } else if (formData?.role && formData?.role !== previousData?.department) {
    return true
  } else*/

  if (JSON.stringify(formData?.checkBoxFormData_0) !== JSON.stringify(previousData?.accessRightsData?.[0]?.data)) {
    return true
  } else if (
    JSON.stringify(formData?.checkBoxFormData_1) !== JSON.stringify(previousData?.accessRightsData?.[1]?.data)
  ) {
    return true
  } else if (
    JSON.stringify(formData?.checkBoxFormData_2) !== JSON.stringify(previousData?.accessRightsData?.[2]?.data)
  ) {
    return true
  } else if (
    JSON.stringify(formData?.checkBoxFormData_3) !== JSON.stringify(previousData?.accessRightsData?.[3]?.data)
  ) {
    return true
  } else if (
    JSON.stringify(formData?.checkBoxFormData_4) !== JSON.stringify(previousData?.accessRightsData?.[4]?.data)
  ) {
    return true
  } else if (
    JSON.stringify(formData?.checkBoxFormData_5) !== JSON.stringify(previousData?.accessRightsData?.[5]?.data)
  ) {
    return true
  } else if (
    JSON.stringify(formData?.checkBoxFormData_6) !== JSON.stringify(previousData?.accessRightsData?.[6]?.data)
  ) {
    return true
  } else if (
    JSON.stringify(formData?.checkBoxFormData_7) !== JSON.stringify(previousData?.accessRightsData?.[7]?.data)
  ) {
    return true
  }

  return false
}
